import { createColumnHelper } from '@tanstack/react-table';

import {
  CasesPerDayRow,
  OrdersByCustomerRow,
  TotalCasesRow,
} from './ordersSummary';

const COUNT_W = 90;
const DATE_W = 120;
const PACKAGES_W = 100;

const ordersByCustomerCol = createColumnHelper<OrdersByCustomerRow>();
const casesPerDayCol = createColumnHelper<CasesPerDayRow>();
const totalCasesCol = createColumnHelper<TotalCasesRow>();

const sized = (width: number) => ({
  size: width,
  minSize: width,
});

export const buildOrdersByCustomerColumns = () => [
  ordersByCustomerCol.accessor('deliveryDate', {
    header: 'Delivery Date',
    ...sized(DATE_W),
  }),
  ordersByCustomerCol.accessor('customer', {
    header: 'Customer',
    ...sized(200),
  }),
  ordersByCustomerCol.accessor('packages', {
    header: 'Packages',
    ...sized(PACKAGES_W),
  }),
  ordersByCustomerCol.accessor('count', {
    header: 'Count',
    ...sized(COUNT_W),
    meta: { align: 'right' as const },
    cell: (info) => (info.getValue() as number).toLocaleString(),
  }),
];

export const buildCasesPerDayColumns = () => [
  casesPerDayCol.accessor('deliveryDate', {
    header: 'Delivery Date',
    ...sized(DATE_W),
  }),
  casesPerDayCol.accessor('packages', {
    header: 'Packages',
    ...sized(PACKAGES_W),
  }),
  casesPerDayCol.accessor('count', {
    header: 'Count',
    ...sized(COUNT_W),
    meta: { align: 'right' as const },
    cell: (info) => (info.getValue() as number).toLocaleString(),
  }),
];

export const buildTotalCasesColumns = () => [
  totalCasesCol.accessor('packages', {
    header: 'Packages',
    ...sized(PACKAGES_W),
  }),
  totalCasesCol.accessor('count', {
    header: 'Count',
    ...sized(COUNT_W),
    meta: { align: 'right' as const },
    cell: (info) => (info.getValue() as number).toLocaleString(),
  }),
  totalCasesCol.accessor('ready', {
    header: 'Ready',
    ...sized(COUNT_W),
    meta: { align: 'right' as const },
    cell: (info) => (info.getValue() as number).toLocaleString(),
  }),
];
